import { API_TIMEOUT } from "Const"
import axios from "./axios"
/**
 * ステータスAPIのリクエスト
 * @return {object} - ステータスAPIのレスポンス結果
 */
export default function getStatus() {
  return axios
    .get("/status")
    .then((res: any) => {
      return res
    })
    .catch((err: any) => {
      return err
    })
}
